(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("speedyScreenProfileMatching", {
            controller: speedyScreenProfileMatching,
            bindings: {
                userData: "<",
                isProfileMatching: "<?",
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/profile-matching/profile-matching.component.html'
        });

    speedyScreenProfileMatching.$inject = ['$scope', 'speedyScreenProfileMatchingService', 'DispatcherServices'];

    function speedyScreenProfileMatching($scope, speedyScreenProfileMatchingService, DispatcherServices) {
        const self = this;
        self.loading = true;
        self.applicantPMInfo = {};
        self.brandId = 0;
        self.components = [];
        self.componentsFeedback = [];
        self.isOldJob = false;

        self.potentialOldJobComponents = ["POSITION_CATEGORY_SIMILARITY", "EMPLOYER_DOMAIN_SIMILARITY", "EDUCATION_LEVEL"];

        const componentsInfo = {
            APPLICANT_AVAILABILITY: {
                infoText: $filter("translate")("Assesses whether the candidate’s availability aligns with the job’s needs (full-time, part-time, seasonal, etc.). Perfect alignment with the job schedule needs achieves the highest score."),
                dislikeReasons: [
                    $filter("translate")("Candidate's availability is compatible but wasn’t recognized.")
                ]
            },
            AVAILABILITY_TIMING: {
                infoText: $filter("translate")("Indicates the candidate's available workdays and preferred shifts (morning, night). This score helps in determining scheduling compatibility with the job's requirements."),
                dislikeReasons: []
            },
            LANGUAGES_MATCHING: {
                infoText: $filter("translate")("Reflects the candidate's proficiency in required languages for the role. Mastery of necessary languages, particularly those critical for the job, results in a higher score."),
                dislikeReasons: [
                    $filter("translate")("The candidate is proficient in the required language but wasn’t recognized."),
                    $filter("translate")("Additional relevant languages were not recognized."),
                ]
            },
            RECENTNESS: {
                infoText: $filter("translate")("Highlights the recency of the candidate's experience in roles similar to the position being applied for. Recent relevant experience scores higher, indicating up-to-date experience."),
                dislikeReasons: [
                    $filter("translate")("Candidate's recent role is highly relevant but wasn’t recognized."),
                    $filter("translate")("The duration of the most recent role was miscalculated."),
                ]
            },
            YEARS_OF_EXPERIENCE: {
                infoText: $filter("translate")("Captures the total work experience of the candidate across all industries, providing insight into overall work life and market experience. This broad metric reflects general professional maturity even if not directly related to the job title."),
                dislikeReasons: []
            },
            POSITION_CATEGORY_SIMILARITY: {
                infoText: $filter("translate")("Assesses the relevance of the candidate's past roles to the position, focusing on job title alignment. Using an AI-powered model, the system analyzes context and recognizes synonymous and related titles, ensuring a nuanced and accurate evaluation beyond exact matches."),
                dislikeReasons: [
                    $filter("translate")("Job title is similar but not recognized by the Profile Matching."),
                    $filter("translate")("Job title synonyms not matched correctly."),
                    $filter("translate")("Role requirements misunderstood.")
                ],
                oldJobKey: "years_of_experience",
            },
            EMPLOYER_DOMAIN_SIMILARITY: {
                infoText: $filter("translate")("Evaluates the candidate's experience in hospitality and retail. Profile Matching prioritizes industry expertise and considers related roles for a broader assessment."),
                dislikeReasons: [
                    $filter("translate")("Candidate's current role level was not correctly matched."),
                    $filter("translate")("Vertical alignment does not reflect the candidate’s career progression."),
                ],
                oldJobKey: "years_of_experience",
            },
            SKILLS_MATCHING: {
                code: 'SKILLS_MATCHING',
                infoText: $filter("translate")("Analyzes the candidate’s skills in relation to the job requirements. Powered by AI, the system identifies direct matches as well as contextually relevant skills, ensuring a comprehensive evaluation beyond explicit matches."),
                dislikeReasons: [
                    $filter("translate")("Key skill(s) missing in the Profile Matching."),
                    $filter("translate")("Skills listed are irrelevant to the role."),
                    $filter("translate")("Candidate's skill level is underestimated."),
                ]
            },
            AVERAGE_TENURE: {
                infoText: $filter("translate")("Analyzes the candidate's job history within the hospitality/Retail industry for patterns of tenure and job changes. Consistent tenure and fewer job changes typically result in a higher stability score."),
                dislikeReasons: [
                    $filter("translate")("Candidate’s tenure length was miscalculated."),
                    $filter("translate")("Frequent job changes don’t reflect instability."),
                    $filter("translate")("Gaps in employment were misunderstood."),
                ]
            },
            EDUCATION_LEVEL: {
                infoText: $filter("translate")("Considers the candidate’s educational background in relation to managerial roles. The score corresponds to how well educational qualifications meet or exceed the role’s requirements."),
                dislikeReasons: [
                    $filter("translate")("Candidate's degree or certification matches but wasn’t recognized."),
                    $filter("translate")("The level of education required (e.g., bachelor’s vs. master’s) was misinterpreted."),
                ],
                oldJobKey: "education_level",
            },
            DISTANCE: {
                infoText: $filter("translate")("Measures the distance between the candidate's address and the job location. A closer distance generally indicates a better match, as it can positively impact factors like commute time, on-time arrival, and overall job satisfaction."),
                dislikeReasons: [
                    $filter("translate")("Distance match score is inaccurate."),
                    $filter("translate")("Candidate’s commute is manageable but scored too low."),
                ]
            }
        };

        const init = async () => {
            self.isProfileMatching = self.isProfileMatching || false;
            self.jobId = self.userData?.job?.id;
            self.applicationId = self.userData?.application_id;
            self.brandId = self.userData?.brand?.id;
            self.candidateId = self.userData?.candidate?.id;
            self.contextBrandId = self.userData?.contextBrand?.id;
            self.smartMatchSelectedBrandId = self.userData?.smartMatchSelectedBrandId;

            if (self.applicationId) {
                await self.getLoadStatusAwareness(self.brandId);
            }
            self.loadUserProfileMatching(self.brandId, self.jobId);
        };

        self.drawChart = () => {
            const chart = new HChart('profile-matching-chart', DispatcherServices.getNunjucks());
            const chartOption = {
                data: {},
                color: {},
                dataType: HChart.CHART_TYPES.DONUT,
                zoomDisabled: true,
                hideLabel: true,
                axis: {},
                size: {
                    height: 100,
                    width: 120
                },
                donut: {
                    expand: false,
                    width: 10,
                    title: self.applicantPMInfo.final_score + '%',
                },
                hideLegend: true
            };
            var columnsData = [
                ['Final Score', self.applicantPMInfo.final_score],
                ['missing', 100 - self.applicantPMInfo.final_score],
            ];
            chartOption["data"]["columns"] = columnsData;
            chartOption["color"]["pattern"] = ['#0091ff', '#dedede'];
            chart.render(chartOption);
        };

        self.loadUserProfileMatching = () => {
            if (self.applicationId) {
                speedyScreenProfileMatchingService.getApplicantProfileMatchingInfo(self.brandId, self.jobId, self.applicationId)
                    .then(async (res) => {
                        if (res.status === ProfileMatchingAPI.LOAD_STATUSES.NOT_LOADED) {
                            self.isloadingData = true;
                        } else {
                            self.applicantPMInfo = res;
                            await self.prepareComponentsFeedback(self.applicantPMInfo.job_application_id);
                            setTimeout(() => {
                                self.drawChart();
                            }, 1000);

                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        self.loading = false;
                        $scope.$digest();
                    });
            } else {
                ProfileMatchingAPI.getJobAssignees(self.smartMatchSelectedBrandId || self.contextBrandId, self.jobId, {candidate_id: self.candidateId})
                    .then((res) => {
                        self.applicantPMInfo = res;
                        self.components = self.applicantPMInfo.components;
                        setTimeout(() => {
                            self.drawChart();
                        }, 1000);
                    })
                    .catch((err) => {
                        self.isloadingData = true;
                        console.error(err);
                    })
                    .finally(() => {
                        self.loading = false;
                        $scope.$digest();
                    });
            }
        };

        self.prepareComponentsFeedback = async (jobApplicationId) => {
            try {
                self.isloadingData = true;
                const res = await ProfileMatchingAPI.getComponentFeedback(self.brandId, self.jobId, {
                    job_application_id: jobApplicationId
                });

                self.componentsFeedback = res.data;
                self.checkIfOldJob(self.applicantPMInfo.components);
                self.components = self.updatedComponents(self.applicantPMInfo.components);
            } catch (err) {
                console.error(err);
            } finally {
                $scope.$digest();
                self.isloadingData = false;
            }
        };

        self.checkIfOldJob = (components) => {
            for (const component of components) {
                const componentInfo = componentsInfo[component.code];
                if (component.code === componentsInfo.SKILLS_MATCHING.code && component.matched_skills?.length === 0 && component.unmatched_skills?.length === 0) {
                    self.isOldJob = true;
                    return;
                }

                if (self.potentialOldJobComponents.includes(component.code) && !component.hasOwnProperty(componentInfo.oldJobKey)) {
                    self.isOldJob = true;
                    return;
                }
            }
        };

        self.updatedComponents = (components) => components.map(component => {
            const componentInfo = componentsInfo[component.code];

            const componentFeedback = self.componentsFeedback?.find(
                (feedback) => feedback.component_id === component.id
            ) || {};

            return {
                ...component,
                InfoIconText: componentInfo.infoText,
                dislikeReasons: componentInfo.dislikeReasons,
                cvLanguage: self.applicantPMInfo.cv_language,
                jobLanguage: self.applicantPMInfo.job_language,
                jobApplicationId: self.applicantPMInfo.job_application_id,
                componentFeedback: componentFeedback.thumb_type ?? "",
                isExpandedCard: !self.isOldJob,
            };
        });

        self.getLoadStatusAwareness = async (brandId) => {
            try {
                const res = await speedyScreenProfileMatchingService.getLoadStatusAwareness(brandId);
                if (res.status !== ProfileMatchingAPI.LOAD_STATUSES.COMPLETED) {
                    self.isloadingData = true;
                }
            } catch (err) {
                console.error(err);
            }
        };

        self.$onInit = () => {
            init();
        };

        self.$onDestroy = () => {
        };
    }
})();
